<template>
  <div class="h-full w-full">
    <!--Logo.vue - logos-->
    <img
      src="../../assets/logo/logo.png"
      class="h-32 w-26 lg:h-36 lg:w-30 mx-auto"
      alt="logo"
    />
    <h1 class="text-5xl text-center font-bold text-black mb-11 normal-case brand">
      Lê Phong Mobile
    </h1>
    <!--VForm - Vuetify-->
    <v-form ref="form" @submit.prevent="submit" v-model="valid" lazy-validation>
      <div class="text-left">
        <v-text-field
          @keypress="filter(evt)"
          v-model="value.phone"
          placeholder="Số điện thoại"
          :rules="[rules.required]"
          outlined
        />
      </div>
      <div class="text-left">
        <!--VTextField - Vuetify-->
        <v-text-field
          v-model="value.password"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          outlined
          placeholder="Mật khẩu"
          :rules="[rules.required]"
          :type="showPass ? 'text' : 'password'"
          @click:append="showPass = !showPass"
        />
      </div>
      <p
        v-for="message in messages"
        :key="message.msg"
        class="w-full text-left text-lg text-danger mb-6"
      >
        {{ message.msg }}
      </p>
      <div class="text-center">
        <v-btn
          type="makeLogin"
          color="primary"
          :min-width="200"
          @click="isErr = !isErr"
          x-large
        >
          Đăng nhập
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { AuthService } from "~/services/auth.service";
import { required } from "~/utils/validation";

export default {
  name: "LoginForm",

  components: {
    logo: () => import("~/components/logos/Logo"),
  },

  data() {
    return {
      showPass: false,
      isErr: false,
      messages: [],
      value: {
        phone: "",
        password: "",
      },
      rules: {
        required,
      },
      valid: true,
      evt: null,
    };
  },
  methods: {
    async submit() {
      await this.$refs.form.validate();

      if (this.valid) {
        try {
          this.$emit("loading", true);
          await AuthService.makeLogin(this.value);
          this.error = "";
          await this.$router.push("/");
        } catch (error) {
          this.error =
            error.status === 404 ? "User with same email not found" : error.message;
        } finally {
          this.$emit("loading", false);
        }
      }
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    prescriptionPublic() {
      this.$router.push({ name: "Verification" });
    },
  },
};
</script>
<style type="sass" scoped>
.brand {
  color: #fbb040;
  font-size: 40px !important;
}
</style>
